import { Box, CircularProgress } from "@mui/material";
import { KeyDriveTabPanel } from "../../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel";
import { KeyDriveSearchBarWithButton } from "../../../../components/KeydriveComponents/SearchBars/KeyDriveSearchBarWithButton";
import { KeyDriveTable } from "../../../../components/KeydriveComponents/Tables/KeyDriveTable";
import { StatePrivilegesTypes } from "../WorkSpacePermissions";
import { GroupPermission } from "../../../../model/GroupModel";
import GroupRowDefault from "../../../../components/KeydriveComponents/Tables/Rows/GroupRowDefault";
import { useTranslation } from "react-i18next";
import { EmptyContainer } from "../../../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { HowToReg } from "@mui/icons-material";
import { PermissionTargetType } from "../../../../enums/PermissionTargetType";

interface IPrivilegesKeydriveTabTwo {
    targetType: PermissionTargetType;
    loadingUsers: boolean;
    setSearchFilter: (set: string) => void;
    allGroupsMemory: GroupPermission[];
    tableHeaders: string[];
    setPrivilegesState?: (set: { state: StatePrivilegesTypes, id: string, permissionType: number }) => void;
}

function PrivilegesKeydriveTabTwo({
    allGroupsMemory,
    loadingUsers,
    setSearchFilter,
    tableHeaders,
    targetType,
    setPrivilegesState
}: IPrivilegesKeydriveTabTwo) {

  const { t } = useTranslation();

    return (
        <KeyDriveTabPanel
            index={1}
            value={targetType == PermissionTargetType.Group ? 1 : 0}
        >
          { loadingUsers ? (
            <CircularProgress variant='indeterminate' />
          ) : (
            <>
              <Box
                mb="12px"
              >
                <KeyDriveSearchBarWithButton 
                  btnText={t("Privileges.DefinePrivilege")}
                  onClick={() => { setPrivilegesState!({ state: "adding group", id: "", permissionType: -1 }) }}
                  onChange={(e) => setSearchFilter(e.currentTarget.value)}
                />
              </Box>
              {allGroupsMemory.length > 0 &&<KeyDriveTable
                headers={tableHeaders}
                body={
                    allGroupsMemory?.map(group => (
                            <GroupRowDefault
                              loading={loadingUsers}
                              group={group}
                              setPrivilegesState={setPrivilegesState}
                            />
                        ))
                }
                needFooter={false}
              />}
              {(allGroupsMemory.length == 0) &&
                                    <Box mt="20px" height="calc(100vh - 400px)">
                                      <EmptyContainer
                                        icon={<HowToReg fontSize='large' sx={{color: "#22638D"}}/>}
                                        title={t("Privileges.NoPrivileges")}
                                        content={t("Privileges.NoPrivilegesGroupText")} />
                                    </Box>
                                  }
            </>
          ) }
        </KeyDriveTabPanel>
    );
}

export default PrivilegesKeydriveTabTwo;